import React, { useRef } from "react";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";

export const TopUpForm = ({ listLoading, applyTopUp }) => {
  const emailRef = useRef();
  const smsRef = useRef();
  const waRef = useRef();

  const Schema = Yup.object().shape({
    email: Yup.number()
      .moreThan(-1)
      .required("Jumlah Email wajb diisi minimal 0"),
    sms: Yup.number()
      .moreThan(-1)
      .required("Jumlah Sms wajb diisi minimal 0"),
    wa: Yup.number()
      .moreThan(-1)
      .required("Jumlah Wa wajb diisi minimal 0"),
  });

  return (
    <Formik
      enableReinitialize
      validationSchema={Schema}
      initialValues={{
        email: 0,
        sms: 0,
        wa: 0,
      }}
      onSubmit={(values) => {
        applyTopUp(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <>
          <div className="form-group row">
            <div className="col-lg-1"></div>
            <div className="col-lg-10 row">
              <div className="col-lg-3 text-center">Email:</div>
              <div className="col-lg-9">
                <input
                  ref={emailRef}
                  onFocus={() => emailRef.current.select()}
                  className="form-control"
                  name="email"
                  placeholder="Tambah Kuota Email"
                  type="number"
                  value={values.email}
                  onChange={(e) => {
                    clearTimeout();
                    setFieldValue(e.target.name, e.target.value);
                    setTimeout(() => {
                      handleSubmit();
                    }, 250);
                  }}
                />
                <ErrorMessage
                  name="email"
                  render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
                />
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
          <div className="form-group row">
            <div className="col-lg-1"></div>
            <div className="col-lg-10 row">
              <div className="col-lg-3 text-center">SMS:</div>
              <div className="col-lg-9">
                <input
                  ref={smsRef}
                  onFocus={() => smsRef.current.select()}
                  className="form-control"
                  name="sms"
                  placeholder="Tambah Kuota SMS"
                  type="number"
                  value={values.sms}
                  onChange={(e) => {
                    clearTimeout();
                    setFieldValue(e.target.name, e.target.value);
                    setTimeout(() => {
                      handleSubmit();
                    }, 250);
                  }}
                />
                <ErrorMessage
                  name="sms"
                  render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
                />
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
          <div className="form-group row">
            <div className="col-lg-1"></div>
            <div className="col-lg-10 row">
              <div className="col-lg-3 text-center">WhatsApp:</div>
              <div className="col-lg-9">
                <input
                  ref={waRef}
                  onFocus={() => waRef.current.select()}
                  className="form-control"
                  name="wa"
                  placeholder="Tambah Kuota WhatsApp"
                  type="number"
                  value={values.wa}
                  onChange={(e) => {
                    clearTimeout();
                    setFieldValue(e.target.name, e.target.value);
                    setTimeout(() => {
                      handleSubmit();
                    }, 250);
                  }}
                />
                <ErrorMessage
                  name="wa"
                  render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
                />
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
          {/* <div>
            <button
              className="btn btn-primary float-right"
              onClick={handleSubmit}
            >
              Bayar
            </button>
          </div> */}
        </>
      )}
    </Formik>
  );
};
